import React from "react";
import { CircularProgress } from "@material-ui/core";
import { InsightsReportViewer } from "./InsightsReportViewer";
import { useInsightsPanelContext } from "./InsightsPanelContext";

export const InsightsFeed = () => {
  const insightsPanelContext = useInsightsPanelContext();

  return !insightsPanelContext.allReports ? (
    <div className="text-center mt-8">
      <CircularProgress />
    </div>
  ) : insightsPanelContext.allReports.length > 0 ? (
    <div className="grid grid-cols-1 xxl:grid-cols-2 xxxl:grid-cols-3 gap-2">
      {insightsPanelContext.allReports.map((report) => (
        <div
          key={report.id}
          onClick={() =>
            insightsPanelContext.setSelectedReport({
              report,
              isEditMode: false,
              isNewlyCreated: false,
            })
          }
        >
          <div
            className={`border-app-slateblue border ${
              report.isPublished && "border-t-8"
            } rounded p-2`}
          >
            <InsightsReportViewer report={report} isThumbnailView={true} />
          </div>
        </div>
      ))}
    </div>
  ) : (
    <>
      <div
        className="text-display-headline text-color-secondary"
        style={{ paddingTop: 0 }}
      >
        Summary insights
      </div>
      <div className="mt-4">
        With Groopit, you can leverage AI to generate or review summary insights
        of any filtered view of the data feed. All published summary insights
        appear for everyone in the group to view. In addition, organizers can
        generate summary insights, edit reports and share them via email.
      </div>
      <div className="mt-2">
        A summary insight contains three components:
        <ol className="list-decimal list-inside">
          <li>A 100-word summary of the aggregated data analyzed.</li>
          <li>
            A key highlight from one of the insights, with a quote from the
            original insight and a description of why it is important or
            relevant.
          </li>
          <li>
            Five recurring themes or patterns across the insights, consisting of
            a pattern title, a brief description of the pattern, and any
            relevant quantitative information about the pattern.
          </li>
        </ol>
      </div>
    </>
  );
};
